import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import keycode from 'keycode';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import {DatePicker} from 'material-ui-pickers';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import {BASE_URL_APIv5} from 'constants/ActionTypes';

const apiUrlHeader = BASE_URL_APIv5;
const apiUrl = apiUrlHeader+"/sales";
const masterTitleLower = "sales";
const masterTitleCapital = "Sales";

// get token and set config for call the API
const token = localStorage.getItem('apiKey')
const companyIdGlobal = localStorage.getItem('companyId')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}
//length data for general
const LENGTH_DATA = 20

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

import InputVirtual from 'components/InputVirtual'

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
      flex: {
        flex: 1,
    },
    button: {
      margin: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    rightIcon: {
      marginLeft: theme.spacing.unit,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
      },
  });

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };
function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
  
    return (
      <SnackbarContent
        className={classNames(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={classNames(classes.iconSnack, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
        {...other}
      />
    );
  }

const MySnackbarContentWrapper = withStyles(theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.dark,
    },
    warning: {
      backgroundColor: amber[700],
    },
    iconSnack: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  }))(MySnackbarContent);

class DialogForm extends React.Component {

    //handle company dd add
    callbackCompany = ({id}) => {
        this.setState({companyIdForm: id})
    };
    // end function ==============================================================================

    async componentDidMount() {
        this.props.showDialog(this.showDialog);
        
    };

    async componentDidUpdate() {
        
        if(this.state.isParentClick == true){
            if(this.props.idData == 0 ){
                this.setState({
                    openDialog: true,
                    action: "tambah",
                    
                    companyIdForm:companyIdGlobal,
                    salesCodeForm: "",
                    nameForm: "",
                    mobileNoForm: "",
                    emailForm: "",
                    birthDateForm: moment().format("YYYY-MM-DD"),
                    birthPlaceForm: "",
                    addressForm: "",
                    hiredDateForm: moment().format("YYYY-MM-DD"),
                    statusForm: true,
                    absentForm: false

                })
            }else{
                this.setState({action: "ubah"});
                this.handleClickOpenEdit(this.props.idData);
            }
            this.setState({ isParentClick : false });
        }
        
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            openDialog: false,
            isParentClick: false,
            action: "tambah",

            //snackbar state
            openSnackSuccess: false,
            openSnackErr: false,
            messageSnackBar:"",

            idData:0,

            //FORM================================================
            companyIdForm:companyIdGlobal,
            salesCodeForm: "",
            nameForm: "",
            mobileNoForm: "",
            emailForm: "",
            birthDateForm: moment().format("YYYY-MM-DD"),
            birthPlaceForm: "",
            addressForm: "",
            hiredDateForm: moment().format("YYYY-MM-DD"),
            statusForm: true,
            absentForm: false
        };

        this.showDialog = this.showDialog.bind(this);
    };

    showDialog() {
        
        this.setState({ isParentClick : true });
    };

    // logic new ================================================================================
    handleClose = async(param) => {
        if(param === 'batal'){
            
            this.setState({ idData:0, openDialog: false });
            this.props.closeDialog(); 
        } else if (param === 'tambah') {
            this.setState({idData:0})
        
            const data = {
                "name" : this.state.nameForm,
                "company" : parseInt(this.state.companyIdForm),
                "sales_code": this.state.salesCodeForm,
                "mobile_no": this.state.mobileNoForm,
                "email": this.state.emailForm,
                "birth_date": moment(this.state.birthDateForm).format("YYYY-MM-DD"),
                "birth_place": this.state.birthPlaceForm,
                "address": this.state.addressForm,
                "hired_date": moment(this.state.hiredDateForm).format("YYYY-MM-DD"),
                "status": this.state.statusForm,
                "absent": this.state.absentForm
            }

            let obj = JSON.stringify(data);
            
            const result = await axios.post(apiUrl+'/new', obj, config)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.status == true){
                NotificationManager.success("Success insert "+masterTitleLower+" data", 'Success message') 
                this.setState({ openDialog: false });
                this.props.closeDialog(result.data); 
            }else{
                NotificationManager.error("Failed insert "+masterTitleLower+" data : "+result.data.message, 'Error message')
            }     
        } else if (param === 'ubah') {
            const {idData} = this.state
        
            const data = {
                "name" : this.state.nameForm,
                "company" : parseInt(this.state.companyIdForm),
                "sales_code": this.state.salesCodeForm,
                "mobile_no": this.state.mobileNoForm,
                "email": this.state.emailForm,
                "birth_date": moment(this.state.birthDateForm).format("YYYY-MM-DD"),
                "birth_place": this.state.birthPlaceForm,
                "address": this.state.addressForm,
                "hired_date": moment(this.state.hiredDateForm).format("YYYY-MM-DD"),
                "status": this.state.statusForm,
                "absent": this.state.absentForm
            }
            let obj = JSON.stringify(data);    
            const result = await axios.put(`${apiUrl}/edit/${idData}`, obj, config)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.status == true){
                
                NotificationManager.success("Success update "+masterTitleLower+" data", 'Success message') 
                
                this.setState({ openDialog: false });
                this.props.closeDialog(result.data);  
            }else{
                NotificationManager.error("Failed update "+masterTitleLower+" data : "+result.data.message, 'Error message')
                
            }
        }
        
    };


    //logic open edit ===========================================================================
    handleClickOpenEdit = async(id) => {
        this.setState({openDialog: true, idData:id})

        const result = await axios.get(`${apiUrl}/${id}`, config)
                            .then(res => res)
                            .catch((error) => error.response )
                          
        if(result.data.status == true){
         
            this.setState({
                companyIdForm:result.data.data.company,
                salesCodeForm: result.data.data.sales_code,
                nameForm:result.data.data.name,
                mobileNoForm: result.data.data.mobile_no,
                emailForm: result.data.data.email,
                birthDateForm: moment(result.data.data.birth_date).format("YYYY-MM-DD"),
                birthPlaceForm: result.data.data.birth_place,
                addressForm: result.data.data.address,
                hiredDateForm: moment(result.data.data.hired_date).format("YYYY-MM-DD"),
                statusForm: result.data.data.status,
                absentForm: result.data.data.absent
            })      
        }
                         
    };

    // end function sales =================================================================
    
    render() {
        const {classes} = this.props

        return (
            <div>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackSuccess}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackSuccess: false })}
                >
                  <MySnackbarContentWrapper
                    onClose={()=> this.setState({ openSnackSuccess: false })}
                    variant="success"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackErr}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackErr: false })}
                >
                  <MySnackbarContentWrapper
                  onClose={()=> this.setState({ openSnackErr: false })}
                    variant="error"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>

                <NotificationContainer/>
                    
                <Dialog
                fullScreen
                open={this.state.openDialog}
                onClose={() => this.handleClose('batal')}
                TransitionComponent={Transition}
                >
                <AppBar className="sticky-container">
                    <Toolbar>
                    <Typography variant="h6" color="inherit" className={classes.flex}>
                        {masterTitleCapital}
                    </Typography>
                    <Button variant="raised" className="bg-white text-black" onClick={() => this.handleClose('batal')}>
                        batal
                    </Button>&nbsp;&nbsp;
                    <Button variant="raised" color="primary" onClick={() => this.handleClose(this.state.action)}>
                        {this.state.action}
                    </Button>
                    </Toolbar>
                </AppBar>
                <br/>
                <br/>
                <div className="app-wrapper">
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                            <Grid item xs={12}>
                            
                                <InputVirtual 
                                    label="Perusahaan"
                                    value=""
                                    name="name"
                                    lengthData={20}
                                    url={apiUrlHeader+"/company/search"}
                                    getData={this.callbackCompany}
                                    setData={[{name:"id",value:this.state.companyIdForm.toString(),"logic_operator":"=","operator":"AND"}]}
                                    fullWidth={true}
                                    dialogForm="DialogFormCompany"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Sales Code"
                                  // className={classes.textField}
                                  value={this.state.salesCodeForm}
                                  fullWidth
                                  onChange={(e) => this.setState({salesCodeForm: e.target.value})}
                                  margin="normal"
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Nama"
                                  // className={classes.textField}
                                  value={this.state.nameForm}
                                  fullWidth
                                  onChange={(e) => this.setState({nameForm: e.target.value})}
                                  margin="normal"
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Phone No."
                                  // className={classes.textField}
                                  value={this.state.mobileNoForm}
                                  fullWidth
                                  onChange={(e) => this.setState({mobileNoForm: e.target.value})}
                                  margin="normal"
                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="Email"
                                  // className={classes.textField}
                                  value={this.state.emailForm}
                                  fullWidth
                                  onChange={(e) => this.setState({emailForm: e.target.value})}
                                  margin="normal"
                                />
                                
                            </Grid>
                            
                        </Grid>

                        <Grid item xs={6}>
                            <Grid item xs={12}>
                                <DatePicker
                                    style={{marginTop:16}}
                                    fullWidth
                                    clearable
                                    label="Birth Date"
                                    value={this.state.birthDateForm}
                                    format="MMMM Do YYYY"
                                    onChange={(date) => this.setState({birthDateForm: date})}
                                    animateYearScrolling={false}
                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Birth Place"
                                  // className={classes.textField}
                                  value={this.state.birthPlaceForm}
                                  fullWidth
                                  onChange={(e) => this.setState({birthPlaceForm: e.target.value})}
                                  margin="normal"
                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="Address"
                                  // className={classes.textField}
                                  value={this.state.addressForm}
                                  fullWidth
                                  onChange={(e) => this.setState({addressForm: e.target.value})}
                                  margin="normal"
                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <DatePicker
                                    style={{marginTop:16}}
                                    fullWidth
                                    clearable
                                    label="Hired Date"
                                    value={this.state.hiredDateForm}
                                    format="MMMM Do YYYY"
                                    onChange={(date) => this.setState({hiredDateForm: date})}
                                    animateYearScrolling={false}
                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <FormControlLabel
                                        value="left"
                                        control={
                                            <Switch
                                            checked={this.state.statusForm}
                                            onChange={(e) => this.setState({statusForm: e.target.checked})}
                                            value="isActive"
                                            color="primary"
                                            />
                                        }
                                        label="Status "
                                />
                                <FormControlLabel
                                        value="left"
                                        control={
                                            <Switch
                                            checked={this.state.absentForm}
                                            onChange={(e) => this.setState({absentForm: e.target.checked})}
                                            value="isActive"
                                            color="primary"
                                            />
                                        }
                                        label="Absent "
                                />
                            </Grid>
                            
                        </Grid>
                        
                    </Grid>
                </div>
                </Dialog>
                
                    
               
            </div>
        );
    }
}

export default withStyles(styles)(DialogForm);


// WEBPACK FOOTER //
// ./app/routes/MasterSales/DialogForm.js